/* eslint-disable */
// This file is generated by the generateThemesRegistry script
import interstateThemeLoader from "./Interstate/interstateThemeLoader";
/**
 * This is the list of registered themes that are used by the InterstateThemeProvider
 * It is generated from the list of themes in the themes.config.json file
 * type {themePropType[]}
 */
export const interstateThemeRegistry = {
  Interstate: {
    themeName: "Interstate",
    themeDisplay: "Interstate Theme",
    themeLoader: interstateThemeLoader
  }
};